<template>
  <router-view></router-view>
</template>
<script>
// import UsersList from './components/UsersList.vue'
export default {
  components: {
    // UsersList,
  },
}
</script>
